import { render } from "./CircleBadge.vue?vue&type=template&id=761ca438"
import script from "./CircleBadge.vue?vue&type=script&lang=js"
export * from "./CircleBadge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CircleBadge.vue"]])

export default __exports__